import React from "react";
import type { CostCenter } from "@meupedaco/shared";
import { CrudPage } from "../../components/CrudPage";

export const CostCentersPage: React.FC = () => {
  return (
    <CrudPage<CostCenter>
      title="Centros de custo"
      endpoint="/modules/cost-centers"
      searchPlaceholder="Buscar por nome ou codigo..."
      columns={[
        { label: "Codigo", render: (item) => item.code ?? "-" },
        { label: "Centro de custo", render: (item) => item.name },
      ]}
      formFields={[
        { name: "code", label: "Codigo", type: "text" },
        { name: "name", label: "Nome", type: "text", required: true },
      ]}
      initialValues={{
        code: "",
        name: "",
      }}
      mapToPayload={(values) => ({
        code: values.code || null,
        name: values.name,
      })}
      permissionWrite="COST_CENTER_WRITE"
    />
  );
};
